/**
 * **Leonardo Hotels**
 *
 * @exports partnership_428
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
              * @memberOf module:partnership_428
              */
    partnership.getId = function getId() {
        return '428';
    };
    /**
              * @memberOf module:partnership_428
              */
    partnership.check = function check() {
        return window.location.hostname.includes('leonardo');
    };
    /**
      * @memberOf module:partnership_428
      */
    partnership.boot = function boot() {
        if (!window.dataLayer) {
            return;
        }
        partnership.shutdown = thn.generateCallbackQueue();
        const refreshPartnership = thn.debounce(thn.siteCheck, 800);
        let dataLayerHelper = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
            if (message.event === 'view_item_list') {
                refreshPartnership();
            }
        }, true);
        partnership.shutdown = function () {
            dataLayerHelper.unlisten();
            dataLayerHelper = null;
        };
    };
    /**
              * @memberOf module:partnership_428
              */
    partnership.getSiteId = function getSiteId() {
        const pathname = window.location.pathname;
        const hotelId = thn.parseUrlParameter('hotel') || pathname.split('/')?.[2];
        const result = hotelId ? { externalId: hotelId.toLowerCase().trim() } : { accountKey: 'FF87BB7947380C4326005CA1AD7588A6' };
        return result;
    };
    return partnership;
}

export { factory };
